// ❤️ Aimer — rendez-vous : l'adversaire part du bout du chemin et vient vers le joueur ; un cœur se
// vide avec le temps, trop vite pour que l'adversaire fasse tout le trajet seul. Le joueur doit
// aller à sa rencontre.
import { baseState, countTick, finish, moveRival, sameCell, stepToward, timeGain } from './common.js';

export const love = {
  id: 'love',
  create(ctx) {
    const length = Math.max(1, ctx.path.length - 1);
    const budget = Math.max(4, Math.ceil(length * 0.75));
    return baseState(ctx, { rival: ctx.path.at(-1), budget, idleTicks: Math.ceil(budget / 3), rivalBadge: 1 });
  },
  tick(state, { grid, player }) {
    let next = countTick(state);
    if (next.result) return next;
    next = moveRival(next, stepToward(grid, next.rival, player));
    next = { ...next, rivalBadge: (next.budget - next.ticks) / next.budget };
    return sameCell(next.rival, player) ? finish(next, 'win') : next;
  },
  enter: (state, { player }) => (sameCell(state.rival, player) ? finish(state, 'win') : state),
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [{ key: 'scenario.love.hint.rival', cell: state.rival }],
};
